export class Modals {

    initialize() {
        this.makeFullscreen('.unify-modal-fullscreen');
    }

    makeFullscreen(selector) {
        var qModal = $(selector);

        if (qModal.length < 1) {

            if (selector !== '.unify-modal-fullscreen') {
                console.error('Could not fullscreen modal. No element matches selector.');
            }

        } else if (qModal.hasClass('modal')) {

            if (!qModal.hasClass('unify-modal-fullscreen')) {
                qModal.addClass('unify-modal-fullscreen');
            }

            if (qModal.parent().get(0) !== document.body) {
                qModal.detach();
                $(document.body).append(qModal);
            }
        } else {
            console.error('Could not fullscreen modal(s). The selected element(s) did not have the class \'modal\'.');
        }
    }

    removeFullscreen(selector) {
        var qModal = $(selector);

        if (qModal.length < 1) {
            if (selector !== '.unify-modal-fullscreen') {
                console.error('Could not remove fullscreen modal. No element matches selector.');
            }

        } else if (qModal.hasClass('modal')) {

            if (qModal.hasClass('unify-modal-fullscreen')) {
                qModal.removeClass('unify-modal-fullscreen');
            }
            
        } else {
            console.error('Could not remove fullscreen modal(s). The selected element(s) did not have the class \'modal\'.');
        }
    }

}
